import {assertAndContinue} from 'Asserts';

let isImporting = false;

/**
 * Mark the app as in the "importing" state so that we can make some safety assertions that we're
 * not running application code at import time.
 *
 * Rather than calling this directly, import the util/start-import-tracker module, which has a
 * side-effect of importing this. The JS spec hoists imports to the top, so any code run before an
 * import statement needs to itself be an import statement.
 */
export function markInitialImportStarted(): void {
  isImporting = true;
}

/**
 * Mark that the initial import has finished, so it's now safe to run any normal application code
 * that calls expectNotImporting.
 *
 * This should usually be imported from the 'util/start-import-tracker' module instead of from here.
 */
export function markInitialImportFinished(): void {
  isImporting = false;
}

/**
 * This function may be called from any application code that we expect to not run during the import
 * process, such as any reducer or render function. We don't need to add this everywhere, but it
 * should be called from a few representative places.
 */
export function expectNotImporting(): void {
  assertAndContinue(
    !isImporting,
    'This code path should not be run on the initial import. Structure your code to use lazy-init ' +
      'so that it runs after initialization. This helps avoid circular import errors and other problems.'
  );
}
